<a href="#" class="image-poster-container">
  <img loading="lazy" src="{{movie.image}}" alt="{{movie.title}}">
</a>